import React from 'react';
import PropTypes from 'prop-types';

const PureImage = props => {
  return (
    <img
      alt=""
      src={props.src}
      style={{ display: 'none', position: 'absolute' }}
      onLoad={props.onLoad}
      draggable={false}
    />
  );
};

PureImage.propTypes = {
  src: PropTypes.string,
  onLoad: PropTypes.func,
};

export default PureImage;
